export * from './Anchor';
export const defaultFrontierConfig = {
    anchor: true,
    anyLink: true,
    brokenImage: true,
    deviceDetector: true,
    dismissable: true,
    drawerToggle: true,
    fileInput: true,
    formValidator: true,
    imageGallery: true,
    lazyImage: true,
    revealOnScroll: true,
    scrollDetector: true,
    scrollProgress: true,
    smoothScroll: true,
    swipeDetector: true,
    toggle: true,
    tooltip: true,
    windowOpener: true
};
